import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { CustomButton, CustomRadio } from '../../../v2/MUI_custom_component';
import StatusBadge from '../../../v2/MUI_custom_component/Badge/StatusBadge';
import moment from 'moment';

const ProductList = ({
  productDetails,
  selectedProductId,
  setSelectedProductId,
  showPOButton,
  onCreatePO,
}) => {
  const isMobile = useMediaQuery('(max-width: 1200px)');
  if (!productDetails || productDetails.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {productDetails.map((product, index) => {
        const isSelected = selectedProductId === product.base_product_id;
        const showRadioButton = productDetails.length > 1;

        return (
          <Box
            key={product.id || index}
            sx={{
              background: '#fff',
              p: 2,
              borderRadius: 2,
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              border:
                productDetails.length > 1 && isSelected
                  ? '2px solid #995A00'
                  : '2px solid #0000',
              cursor: showRadioButton ? 'pointer' : 'default',
              position: 'relative',
              '&:hover': showRadioButton
                ? {
                    borderColor: '#995A00',
                  }
                : {},
            }}
            onClick={() => {
              if (showRadioButton) {
                setSelectedProductId(product.id);
              }
            }}
          >
            <Box
              sx={{
                display: 'flex',
                gap: 2,
                width: '100%',
                alignItems: 'flex-start',
              }}
            >
              <Box
                component='img'
                src={product.product_image}
                alt={product.product_company_name}
                sx={{
                  maxHeight: 200,
                  objectFit: 'contain',
                  width: '64px',
                  height: '64px',
                  borderRadius: 1,
                  border: '1px solid #D9D9D9',
                  flexShrink: 0,
                }}
              />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1,
                  gap: 1,
                }}
              >
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  {product.product_company_name && (
                    <Typography variant='bodyL' sx={{ flex: 1 }}>
                      {product.product_company_name ?? '--'}
                    </Typography>
                  )}
                  <Typography variant='p3' sx={{ flex: 1, marginTop: 0.5 }}>
                    {product.base_product_name ?? '--'}
                  </Typography>
                </Box>

                <Box
                  sx={{ display: 'flex', flexDirection: 'column', }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                    }}
                  >
                    <Typography
                      variant='labelM'
                      sx={{ color: '#666', minWidth: '100px' }}
                    >
                      Today's Price
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      <Typography variant='p3' sx={{minWidth:'44px'}}>
                        ₹ {product.current_price_per_unit ?? "--"}
                      </Typography>
                      <StatusBadge
                        variant={'text'}
                        label='Ex Factory Price'
                        size={isMobile ? 'small' : 'medium'}
                        color={'#0081F2'}
                      />
                    </Box>
                  </Box>
                  {product.length && (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      <Typography
                        variant='labelM'
                        sx={{ color: '#666', minWidth: '100px' }}
                      >
                        Length
                      </Typography>
                      <Typography variant='p3'>{product.length ?? '--'}</Typography>
                    </Box>
                  )}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                    }}
                  >
                    <Typography
                      variant='labelM'
                      sx={{ color: '#666', minWidth: '100px' }}
                    >
                      Last price change
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      <Typography variant='p3'>
                        {moment(product.last_updated).format('DD/MM/YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            {showPOButton && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <CustomButton
                  label='Create PO'
                  variant='filled'
                  size={isMobile ? 'small' : 'medium'}
                  color='primary'
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedProductId(product.id);
                    onCreatePO(product);
                  }}
                />
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default ProductList;